import styled from 'styled-components';

export const Container = styled.div`
  overflow-y: scroll;
  height: 100%;

  ::-webkit-scrollbar {
    width: 24px;
    height: 18px;
  }
  ::-webkit-scrollbar-thumb {
    height: 6px;
    border: 8px solid rgba(0, 0, 0, 0);
    background-clip: padding-box;
    border-radius: 12px;
    background-color: rgba(0, 0, 0, 0.15);
  }
  ::-webkit-scrollbar-button {
    width: 0;
    height: 0;
    display: none;
  }
  ::-webkit-scrollbar-corner {
    background-color: transparent;
  }
`;

export const Table = styled.table`
  border-collapse: collapse;
  width: 100%;

  thead {
    position: -webkit-sticky;
    position: sticky;
    top: 0;
    z-index: 9;
    border-bottom: 1px solid #d8dae5;
  }

  th {
    text-align: left;
    background: #fff;
  }

  td {
    padding: 16px 0;
    color: #1a1b1c;
    font-size: 16px;
  }

  tr + tr {
    border-top: 1px solid #d0dae3;
  }
`;

export const User = styled.div`
  display: flex;
  align-items: center;
`;

export const Profile = styled.img`
  width: 20px;
  height: 20px;
  border-radius: 10px;
`;

export const MenuIcon = styled.img`
  cursor: not-allowed;
`;

export const Head = styled.div`
  background: #fff;
  padding-top: 7px;
  padding-bottom: 7px;
  color: #8f95b2;
  font-weight: 500;
  font-size: 12px;

  &.email-header {
    border-top-left-radius: 8;
    border-bottom-left-radius: 8;
    padding-left: 7;
  }

  &.status-header {
    padding-right: 7;
  }

  &.menu-header {
    border-top-right-radius: 8;
    border-bottom-right-radius: 8;
  }
`;

export const Status = styled.div`
  display: flex;
  align-items: center;
`;

interface IStatusCircle {
  status: 'expired' | 'accepted' | 'sent';
}

export const StatusCircle = styled.div<IStatusCircle>`
  background: ${({ status }) => {
    if (status === 'expired') {
      return '#EA1212';
    }

    if (status === 'accepted') {
      return '#249D0E';
    }

    return '#E3E3E3';
  }};
  width: 6px;
  height: 6px;
  border-radius: 3px;
`;

export const MenuDiv = styled.div`
  visibility: hidden;
  font-size: inherit;
`;

interface IDivider {
  width?: string;
  height?: string;
}

export const Divider = styled.div<IDivider>`
  width: ${({ width }) => width};
  height: ${({ height }) => height};
`;

interface IText {
  status?: string;
}

export const Text = styled.div<IText>`
  font-size: 14px;
  font-weight: 400;
  color: ${({ status }) => {
    if (status === 'accepted') return '#474d66';
    return '#8f95b2';
  }};

  &.role {
    color: #474d66;
  }
`;

export const MenuContainer = styled.div`
  display: flex;
`;

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: row;
  color: #8f95b2;
  font-size: 12px;
  font-weight: 500;
`;

export const Span = styled.div`
  margin-left: 8px;
  padding-bottom: 1px;
`;
